import * as React from 'react'
import { Form, Input, Button, Select, Row, Col, FormInstance } from 'antd'
import { LoginDevice } from '../../../../javascripts/public';

interface PropsType {
    login: Function
    sendCaptcha: Function
    forget: Function,
    loginFailData: string
}

const Option = Select.Option;
const FormItem = Form.Item;

class LoginForm extends React.Component<PropsType> {


    formRelf;
    constructor (props) {
        super(props);
        this.formRelf = React.createRef<FormInstance>();
    }

    state = {
        count: 0
    }

    onFinish = (values) => {
        console.log('Received values of form: ', values);
        localStorage.setItem('username', values.mobileNumber);
        localStorage.setItem('loginDevice', values.device);
        this.props.login(values, true);
    }

    onFinishFailed = (errorInfo) => {
        console.log('error', errorInfo)
    }

    intId;
    onSendCaptcha = () => {
        let mobileNumber = this.formRelf.current.getFieldValue('mobileNumber') ;
        if(mobileNumber == '') {
            
        }
        else {
            this.setState({
                count: 60
            });
            let that  = this;
            that.intId = setInterval(() => {
                let count = that.state.count;
                console.log(count);
                if(count === 0) {
                    window.clearInterval(that.intId)
                }
                else {
                    that.setState({
                        count: count - 1
                    });
                }
            }, 1000);
            this.props.sendCaptcha(mobileNumber)
        }
       
    }

    render() {

        let loginFailData = this.props.loginFailData;
        let loginDevice = localStorage.getItem('loginDevice') || LoginDevice.SCANNER;

        return (
            <Form 
                onFinish={this.onFinish} 
                onFinishFailed={this.onFinishFailed}
                className="login-form"
                ref={this.formRelf}
                initialValues={{
                    device: loginDevice,
                }}
                >
                <FormItem
                    name='device'
                    rules={[{ required: true, message: '请选择设备', whitespace: true }]}>
                    <Select>
                        <Select.Option value={LoginDevice.SCANNER}>扫脚仪</Select.Option>
                        <Select.Option value={LoginDevice.SILIZHU}>四立柱</Select.Option>
                    </Select>
                </FormItem>
                <FormItem 
                    name='mobileNumber' 
                    rules={[{ required: true, message: '请输入手机号', whitespace: true }]}
                    >
                    <Input 
                        size="large" 
                        addonBefore='+86'
                        placeholder="请输入手机号"
                        />
                </FormItem>
                <Row>
                    <Col span={14}> 
                        <FormItem 
                            name='captcha' 
                            rules={[{ required: true, message: '请输入验证码', whitespace: true }]}
                            >
                            <Input 
                                size="large" 
                                placeholder="请输入验证码" 
                                />
                        </FormItem>
                    </Col>
                    <Col span={10}>
                        {
                            this.state.count === 0 ? 
                            <Button 
                                size="large"
                                className="btn_get_captcha" 
                                onClick={() => this.onSendCaptcha()}
                                >获取短信验证码</Button>
                                :
                            <Button 
                                disabled={true}
                                size="large"
                                className="btn_get_captcha" 
                                >{this.state.count}s</Button>
                        }
                       
                    </Col>
                </Row>
                <div className="overflow-hidden">
                    <a className="right" onClick={() => this.props.forget()}>忘记密码</a>
                </div>
                <FormItem>
                    <Button 
                        type="primary" 
                        size="large" 
                        htmlType="submit" 
                        className='btn_password_login'
                        >登录</Button>
                    {loginFailData && <p className="error">{loginFailData}</p>}
                </FormItem>
            </Form>
        );
    }
}
   
export default LoginForm